export default __webpack_public_path__ + "static/media/ic-phone-black.6d02d61b.svg";